import React from "react";
import { connect } from "react-redux";
import WebFont from "webfontloader";
import { ThemeFieldWrapper, ThemesWrapper } from "./styledComponents";
import { AppPreview, PhotoFilterPreview } from "./components";
import { Controller, useWatch } from "react-hook-form";

export const ThemeField = ({
  value,
  appPreview,
  filterPreview,
  selected,
  theme,
  themeInstance,
  backgroundColor,
  isField,
  onThemeSelect,
  form,
}) => {
  WebFont.load({
    google: {
      families: [theme.font],
    },
    fontinactive: (familyName, _fvd) => {
      WebFont.load({
        typekit: {
          id: familyName,
        },
      });
    },
  });
  const { control } = form;
  const values = useWatch({ control: control });
  const appColor = values["app_background_color"];
  const firstLine = values["first_line_text"];
  const secondLine = values["second_line_text"];
  const withGraphic = values["with_photo_filter_graphic"];
  const withFilter = values["with_photo_filter"];

  return (
    <ThemeFieldWrapper selected={selected}>
      <AppPreview
        shrink
        firstLineFieldName={selected && "first_line_font_shrink"}
        secondLineFieldName={selected && "second_line_font_shrink"}
        selectedTheme={theme}
        themeInstance={themeInstance}
        backgroundColor={backgroundColor}
        appColor={appColor}
        firstLine={firstLine}
        secondLine={secondLine}
      />
      <PhotoFilterPreview
        small
        selectedTheme={theme}
        themeInstance={themeInstance}
        firstLine={firstLine}
        secondLine={secondLine}
        withGraphic={withGraphic}
        withFilter={withFilter}
      />
      {isField && (
        <Controller
          control={control}
          name="channel_theme_id"
          render={({ field: { ref, ...fieldRest } }) => (
            <input
              {...fieldRest}
              value={value}
              onChange={(e) => {
                if (fieldRest.value !== theme.id) {
                  fieldRest.onChange(theme.id);
                } else {
                  fieldRest.onChange(null);
                }
                onThemeSelect();
              }}
              type="radio"
            />
          )}
        />
      )}
    </ThemeFieldWrapper>
  );
};

const PhotographerThemeForm = (props) => {
  const {
    themeId,
    setThemeIdFunction,
    channelThemes,
    themeInstanceId,
    channelThemeInstances,
    backgroundColor,
    nextTab,
    isNew,
    form,
  } = props;
  const themeInstance = isNew ? null : channelThemeInstances[themeInstanceId];
  const { setValue } = form;
  const setDefaultColor = (color) => {
    setValue("background", color);
  };

  return (
    <ThemesWrapper>
      {!!channelThemes &&
        Object.keys(channelThemes).map((k) => (
          <ThemeField
            isField
            key={k}
            value={k}
            theme={channelThemes[k]}
            selected={(themeId && themeId.toString()) === k}
            themeInstance={themeInstance}
            backgroundColor={backgroundColor}
            onThemeSelect={(theme) => {
              if (backgroundColor === "" || !backgroundColor) {
                if (isNew) {
                  setThemeIdFunction(channelThemes[k].id);
                }
                setDefaultColor(channelThemes[k].default_app_background_color);
              }
              nextTab();
            }}
            form={form}
          />
        ))}
    </ThemesWrapper>
  );
};

export default connect(null, {})(PhotographerThemeForm);
